import { type RootState } from "~/app/store";

export const selectRegionaBannerVisibility = (state: RootState): boolean => {
  return state.regionSelectionBanner.isVisible;
};
